// src/components/AlbumSongList.js

import React, { useEffect } from 'react';
import { useQuery, gql } from '@apollo/client';
import './AlbumSongList.css';

const GET_SONGS_BY_ARTIST = gql`
  query GetSongsByArtist($artistPageId: ID!) {
    getSongsByArtist(artistPageId: $artistPageId) {
      id
      title
      album {
        id
        title
      }
    }
  }
`;

const AlbumSongList = ({ artistPageId, refetchTrigger }) => {
  const { data, loading, error, refetch } = useQuery(GET_SONGS_BY_ARTIST, {
    variables: { artistPageId },
  });

  useEffect(() => {
    if (typeof refetchTrigger === 'function') {
      refetchTrigger(() => refetch());
    }
  }, [refetchTrigger, refetch]);

  if (loading) return <p>Loading songs...</p>;
  if (error) return <p>Error loading songs: {error.message}</p>;

  const songsGroupedByAlbum = data.getSongsByArtist.reduce((acc, song) => {
    const albumTitle = song.album?.title || 'No Album';
    if (!acc[albumTitle]) acc[albumTitle] = [];
    acc[albumTitle].push(song);
    return acc;
  }, {});

  return (
    <div className="album-song-list">
      <h3>All Songs by Album</h3>
      {Object.entries(songsGroupedByAlbum).map(([albumTitle, songs]) => (
        <div key={albumTitle} className="album-section">
          <h4>{albumTitle}</h4>
          <ul>
            {songs.map((song) => (
              <li key={song.id}>{song.title}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default AlbumSongList;
